import * as React from 'react';
const Svg7 = (props) => (React.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props },
    React.createElement("path", { d: "M7.356 22a1.07 1.07 0 0 1-.918-1.622l9.74-16.235H5.929a1.072 1.072 0 0 1 0-2.143h12.143a1.073 1.073 0 0 1 .92 1.622L8.275 21.48c-.201.332-.556.52-.92.52Z", fill: "currentColor" })));
export default Svg7;
